(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('ApiService', ApiService)

    /** @ngInject */
    function ApiService(HttpService) {
        const ApiService = {
            getControllers: getControllers,
            saveAccessLevelPermissions: saveAccessLevelPermissions,
            saveCustomPermissions: saveCustomPermissions
        }

        return ApiService;

        function getControllers() {
            return HttpService.get('/api-controllers');
        }

        function saveAccessLevelPermissions(permissionData) {
            return HttpService.post('/api-controllers/access-levels', permissionData);
        }

        function saveCustomPermissions(permissionData, personUnitId) {
            return HttpService.post(`/api-controllers/person-units/${personUnitId}`, permissionData);
        }
    }
}());